// Registers the PWA service worker (public/sw.js) in production builds.
// In development we unregister it so live reload and fresh assets aren't cached.
export function register() {
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    if (process.env.NODE_ENV === 'production') {
      navigator.serviceWorker
        .register(`${process.env.PUBLIC_URL}/sw.js`)
        .catch((err) => console.error('Service worker registration failed:', err));
    } else {
      navigator.serviceWorker.getRegistrations().then((regs) => {
        regs.forEach((reg) => reg.unregister());
      });
    }
  });
}
